import { interactionType } from "../actionType/actionType";

const initialState = {
  openDrawer: false,
  photoChangedMatch:false,
  payMenu:false,
  paymentSuccess:false,
  notification:false,
  openLeaveForm:false,
};



export const interactionReducer = (state = initialState, action) => {
  
  switch (action.type) {
    case interactionType.OPEN_CLOSE_MENU: {
      return {
        ...state,
        openDrawer: action.payload,
      };
    }
    case interactionType.PHOTO_CHANGE: {
      return {
        ...state,
        photoChangedMatch: action.payload
      }
    }

    case interactionType.PAY_MENU:{
      return{
        ...state,
        payMenu: action.payload
      }
    }

    case interactionType.PAY_MENU_NEW:{
      return{
        ...state,
        payMenuNew: action.payload
      }
    }

    case interactionType.SUCCESSFULL_PAYMENT:{
      return{
        ...state,
        paymentSuccess:true
      }
    }

    case interactionType.NOTIFICATION_DRAWER:{
      return{
        ...state,
        notification: action.payload
      }
    }

    case interactionType.OPEN_CLOSE_LEAVE_FORM:{
      return{
        ...state,
        openLeaveForm:action.payload
      }
    }

    default: {
      return state;
    }
  }
};
